import React from 'react';

import FlatButton from '../../../FlatButton';

import cx from '../../../../utils/classnames';

import styles from '../../pagination.module.scss';

import type { Squeeze } from '../../helper';

type PageButtonsProps = {
  pageList: Array<number | Squeeze>;
  activePage: number;
  limit: number;
  onChangePage: (offset: number, limit: number) => void;
  buttonType?: 'light' | 'dark' | 'simple' | 'outlined' | 'domestic';
  paginationButtonWrapperClassName?: string;
  paginationButtonClassName?: string;
  paginationActiveButtonClassName?: string;
};

export default function PageButtons(props: PageButtonsProps) {
  const {
    pageList,
    activePage,
    limit,
    onChangePage,
    buttonType,
    paginationButtonWrapperClassName,
    paginationButtonClassName,
    paginationActiveButtonClassName,
  } = props;

  return (
    <span
      className={cx(styles.body, paginationButtonWrapperClassName)}
      data-testid="pageButtons-wrapper"
    >
      {pageList.map((item) => {
        if (typeof item === 'object') {
          return (
            <span
              data-testid="pageButtons-symbol"
              key={item.id}
              className={buttonType === 'outlined' ? styles.outlinedDots : styles.pageGap}
            >
              {item.symbol}
            </span>
          );
        }

        const handleButtonChangePage = () => {
          onChangePage(limit * (item - 1), limit);
        };

        if (item === activePage) {
          return buttonType === 'outlined' ? (
            <button
              key={item}
              className={styles.activeWithoutBox}
              onClick={handleButtonChangePage}
              data-testid="pageButtons-activeItem"
            >
              {activePage}
            </button>
          ) : (
            <FlatButton
              className={cx(styles.active, paginationActiveButtonClassName)}
              key={item}
              onClick={handleButtonChangePage}
              data-testid="pageButtons-activeItem"
            >
              {activePage}
            </FlatButton>
          );
        }

        return buttonType === 'outlined' ? (
          <button
            key={item}
            className={styles.normalWithoutBox}
            onClick={handleButtonChangePage}
            data-testid="pageButtons-item"
          >
            {item}
          </button>
        ) : (
          <FlatButton
            key={item}
            className={cx(styles.normal, paginationButtonClassName)}
            onClick={handleButtonChangePage}
            classType="secondary"
            data-testid="pageButtons-item"
          >
            {item}
          </FlatButton>
        );
      })}
    </span>
  );
}
